/** Estilos y formateadores compartidos por las pantallas de garantías. */
import { FP } from "components/financepro";

export const btnBase = {
  textTransform: "none",
  borderRadius: 1.8,
  fontWeight: 700,
  boxShadow: "none",
};
export const btnSolid = (bg = FP.color.navy, hover = FP.color.navySoft) => ({
  ...btnBase,
  bgcolor: bg,
  color: "#FFFFFF",
  "&:hover": { bgcolor: hover, boxShadow: "none", color: "#FFFFFF" },
  "&.Mui-disabled": { bgcolor: `${bg}66`, color: "#FFFFFF" },
});
export const btnOutline = (c = FP.color.navy) => ({
  ...btnBase,
  color: c,
  bgcolor: "#FFFFFF",
  border: `1px solid ${c}`,
  "&:hover": { bgcolor: `${c}12`, border: `1px solid ${c}`, color: c },
});

export const sectionBox = {
  border: `1px solid ${FP.color.border}`,
  borderRadius: 2.5,
  p: { xs: 2, sm: 2.6 },
  bgcolor: FP.color.cardBg,
  boxShadow: FP.shadow.soft,
};

export const etiquetaSeccion = {
  fontSize: "0.7rem",
  fontWeight: 700,
  letterSpacing: "0.1em",
  textTransform: "uppercase",
  color: FP.color.textSecondary,
};

export const fmtMonto = (v) =>
  Number(v || 0).toLocaleString("es-DO", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export const fmtPrecio = (v) => (Number(v) > 0 ? `RD$${fmtMonto(v)}` : "Gratis");

export const CONDICION = { N: "Nueva", U: "Usada" };

/** Cédula/chasis comparables: sin guiones ni espacios, en mayúsculas. */
export const normalizarBusqueda = (txt) =>
  String(txt || "")
    .replace(/[\s-]/g, "")
    .toUpperCase();
